<template>
    <b-modal ref="modal" :hide-footer="true">
        <template slot="modal-header" >

                <a href="#" @click.prevent="typeOfUpload = 'noLink'" v-if="typeOfUpload !== 'noLink'">
                  <i class="fas fa-arrow-left"></i>
                </a>
                <span class="title-separator" v-if="typeOfUpload !== 'noLink'" style="margin-right: -120px;margin-left: -120px">|</span>
                <h1> Upload
                 <span class="count">{{files.length}}</span> files
            </h1>
            <div>
                <Button
                        :empty="true"
                        class="close-popup"
                        @click.prevent="$refs.modal.hide()"
                >{{ Translations.buttons.cancel }}
                </Button>
                <Button :disabled="!uploadBtnStatus"
                        :empty="true"
                        :noBorder="true"
                        color="#d2d2d2"
                        class="validate"
                        @click.prevent="confirm"
                >Upload
                </Button>
            </div>
        </template>
        <template>
            <div class="upload">
                <div class="body">
                  <template>
                      <input id="royalty_free"
                            v-model="royaltyFree"
                            name="royalty_free"
                            :checked="royaltyFree"
                            type="checkbox"/>
                      <label  @click="royaltyFree= !royaltyFree" style="margin-left:7px ; margin-bottom:20px"> Royalty free - Use tags for automatic recognition</label>
                  </template>          
                  <template v-if="typeOfUpload === 'noLink'">
                    <h3>Specify file type</h3>
                    <ul class="upload-box">
                        <li v-if="currentStation && currentStation.allowTrackUpload">
                            <input
                                    id="type_music"
                                    v-model="trackType"
                                    name="track_type"
                                    type="radio"
                                    :value="Constants.trackTypes.MUSIC"
                            />
                            <label for="type_music">Music</label>
                        </li>
                        <li>
                            <input
                                    id="type_jingle"
                                    v-model="trackType"
                                    name="track_type"
                                    type="radio"
                                    :value="Constants.trackTypes.JINGLE"
                            />
                            <label for="type_jingle">Jingle</label>
                        </li>
                        <li>
                            <input
                                    id="type_podcast"
                                    v-model="trackType"
                                    name="track_type"
                                    type="radio"
                                    :value="Constants.trackTypes.PODCAST"
                            />
                            <label for="type_podcast">Podcast</label>
                        </li>
                       </ul>
                      <br/>
                     </template>
                      <template v-if="trackType === Constants.trackTypes.MUSIC && typeOfUpload === 'noLink'">
<!--                      <hr style="padding: 0 15px 0 15px">-->
                        <span><h3>Link to box/playlist</h3></span>
                      <br/>
                      <div>
<!--                        <button class="empty ml-2" @click.prevent="saveAndStay">No link </button>-->
                        <button class="empty ml-2"  style="margin-right: 30px!important" @click.prevent="typeOfUpload ='LinkExisting'">Link existing</button>
                        <button class="empty ml-2" @click.prevent="typeOfUpload ='LinkToNewBox'">Create new box/playlist</button>
                      </div>
                      </template>
                  <template v-if="typeOfUpload === 'LinkExisting'">
                    <div class="search-container">
                      <div class="search-content">
                    <div id="box-source" class="source-column">
                      <ul v-if="activeStation">
                        <li class="header">
                          <h4>Boxes</h4>
                        </li>
                        <li :class="['box-source', {'active':(selectedBoxes[box.uid]||{}).uid == box.uid}]" v-for="box in stationMusicBoxes" :key="box.uid" @click.prevent="toggleBox(box)">
                          <span class="box-source-wrapper">
                            <i class="fas fa-check"></i>
                            {{box.name}}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div id="station-source" class="source-column">
                      <ul>
                        <li class="header">
                          <h4>
                            Playlists
                          </h4>
                        </li>
                        <li :class="['box-source', {'active':(selectedBoxes[box.uid]||{}).uid == box.uid}]" v-for="box in stationMusicPlaylist" :key="box.uid" @click.prevent="toggleBox(box)">
                          <span class="box-source-wrapper">
                            <i class="fas fa-check"></i>
                            {{box.name}}
                          </span>
                        </li>
                      </ul>
                    </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="typeOfUpload === 'LinkToNewBox'">
                    <h4>{{ Translations.buttons.createBox }}</h4><hr>
                    <b-form class="form" @submit.prevent="createBox">
                      <input type="hidden" id="stationUid" name="stationUid" v-model="boxData.stationUid" />
                      <div class="linked-properties">
                        <b-form-group id="group-name" :label="Translations.labels.name" label-for="name" :label-cols="4">
                          <b-form-input autofocus id="name" name="name" v-model="boxData.name" type="text" required autocomplete="off" :placeholder="Translations.placeholders.name" />
                        </b-form-group>
                        <b-form-group id="color-container" :label="Translations.labels.color" label-for="colorCode" :label-cols="4">
                          <b-form-input id="name" name="colorCode" v-model="boxData.colorCode" type="color" :placeholder="Translations.placeholders.color" />
                        </b-form-group>
                      </div>
                      <div >
<!--                        <span class="detail-label">Style(s)</span>-->
                        <b-form-group id="group-style" :label="'Styles'" label-for="style" :label-cols="4">
                            <StyleBadgeList
                                :styles="boxData.styles"
                                ref="styles"
                                :readOnly="true"
                                placeholder
                                @onFocus="onFocus('styles')"
                                @onBlur="onBlur"
                                @click.prevent="openParameterSelector('showStyleSelector','modalStyles', [boxData])"
                            />
<!--                        <span class="detail-error">This field is required</span>-->
                        </b-form-group>
                      </div>
                      <div >
                        <b-form-group id="group-categories" :label="'Categories'" label-for="categories" :label-cols="4">
<!--                        <span class="detail-label">categories</span>-->
                            <StyleBadgeList
                                :styles="boxData.categories"
                                ref="styles"
                                :readOnly="true"
                                placeholder
                                @onFocus="onFocus('categories')"
                                @onBlur="onBlur"
                                @click.prevent="openParameterSelector('showCategoriesSelector','modalCategories', [boxData])"
                            />
<!--                        <span class="detail-error">This field is required</span>-->
                        </b-form-group>
                      </div>
                      <div >
                        <b-form-group id="group-targets" :label="'Targets'" label-for="targets" :label-cols="4">
  <!--                        <span class="detail-label">Targets</span>-->
                          <StyleBadgeList
                              :styles="boxData.targets"
                              ref="styles"
                              :readOnly="true"
                              placeholder
                              @onFocus="onFocus('targets')"
                              @onBlur="onBlur"
                              @click.prevent="openParameterSelector('showTargetSelector','modalTargets', [boxData])"
                          />
<!--                        <span class="detail-error">This field is required</span>-->
                        </b-form-group>
                      </div>
                      <div class="linked-properties">
                        <b-form-group :label="Translations.labels.boxType" label-for="boxType" :label-cols="4">
                          <b-form-radio-group id="boxType" name="type" v-model="boxData.type"
                                              :options="boxTypes">
                          </b-form-radio-group>
                        </b-form-group>
                        <b-form-group v-if="boxData.type == boxTypes.BOX.value" :label="Translations.labels.trackType" label-for="trackType" :label-cols="4">
                          <b-form-select id="trackType" name="trackType" v-model="boxData.trackType" :options="trackTypes" :placeholder="Translations.placeholders.trackType">
                          </b-form-select>
                        </b-form-group>
                      </div>
                    </b-form>
                  </template>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <a href="#" @click.prevent="$refs.modal.hide()">Cancel</a>
            <button class="primary"  :disabled="uploadBtnStatus" @click.prevent="confirm">Upload</button>
        </template>
      <SelectorStyle
          v-show="viewState.showStyleSelector"
          ref="modalStyles"
          :stationUid="boxData.stationUid"
          :noModalEdit="true"
          @newValue="onNewValueStyles"
          @onHidden="resetModalState('showStyleSelector')"
      />
      <SelectorCategories
          v-show="viewState.showCategoriesSelector"
          ref="modalCategories"
          :stationUid="boxData.stationUid"
          :noModalEdit="true"
          @newValueCategories="onNewValueCategories"
          @onHidden="resetModalState('showCategoriesSelector')"
      />
      <SelectorTargets
          v-show="viewState.showTargetSelector"
          ref="modalTargets"
          :stationUid="boxData.stationUid"
          :noModalEdit="true"
          @newValueTargets="onNewValueTargets"
          @onHidden="resetModalState('showTargetSelector')"
      />
    </b-modal>

</template>

<script>
    import Bootstrap from "bootstrap-vue";
    import Constants from "@/store/constants";
    import Translations from "@/store/translations";
    import {mapState} from 'vuex'
    import {HTTP} from "@/utils/http";
    import Apis from "@/apis";
    import BoxCreationCard from "@/components/Boxes/BoxCreationCard";
    import router from "@/router";
    import store from "@/store";
    import StyleBadgeList from "@/components/common/StyleBadgeList";
    import SelectorStyle from "@/components/Library/SelectorStyle";
    import SelectorCategories from "@/components/Boxes/SelectorCategorie";
    import SelectorTargets from "@/components/Boxes/SelectorTarget";
    // import store from '../../store/index'

    export default {
        name: "UploadType",
        store,
        components: {BoxCreationCard , StyleBadgeList, SelectorStyle , SelectorCategories , SelectorTargets},
        props: {
          files: {type: Array, default: () => []},
          type: {type: [String, Number], required: true}
          // stationUid: {type: String}
        },
        computed: {
            ...mapState(['currentStation' ]),
            Translations: () => Translations,
            Constants: () => Constants,
          stationMusicBoxes() {
            if (!this.activeStation) return [];
            if (!this.stationBoxes) return [];
            // allow only music boxes
            return ((this.stationBoxes[this.activeStation.uid] || {}).items || [])
                .filter(
                    itm =>
                        (itm.type === Constants.boxTypes.BOX.key ||
                            itm.type === Constants.boxTypes.BOX.value) &&
                        (itm.trackType === Constants.trackTypes.MUSIC.key ||
                            itm.trackType === Constants.trackTypes.MUSIC.value)
                )
                .sort(function(a, b) {
                  return (a.name || "").localeCompare(b.name);
                });
          },
          stationMusicPlaylist() {
            if (!this.activeStation) return [];
            if (!this.stationBoxes) return [];
            // allow only music boxes
            return ((this.stationBoxes[this.activeStation.uid] || {}).items || [])
                .filter(
                    itm =>
                        (itm.type === Constants.boxTypes.PLAYLIST.key ||
                            itm.type === Constants.boxTypes.PLAYLIST.value)
                )
                .sort(function(a, b) {
                  return (a.name || "").localeCompare(b.name);
                });
          },
          trackTypes: function () {
            switch (this.boxData.type) {
              case Constants.boxTypes.BOX.value:
                return [
                  Constants.trackTypes.MUSIC,
                 // Constants.trackTypes.JINGLE,
                  // Constants.trackTypes.PROMO,
                  // Constants.trackTypes.VOICE_TRACK,
                 // Constants.trackTypes.PODCAST,
                  //Constants.trackTypes.FILLER
                ];
              case Constants.boxTypes.PLAYLIST.value: return [Constants.trackTypes.UNDEFINED];
              default: return null;
            }
          },
          boxTypes: function () {
            return Constants.boxTypesWithoutSmartBox;
          }
          ,
          errorMessages: function (inputName) {
            if (this.creationResponse == null || this.creationResponse.errors == null) return [];
          },
          isFormValid() {
            const { name } = this.boxData;
            return name && name.trim().length;
          },
          uploadBtnStatus(){
            let blockForm = false;
            if (this.typeOfUpload === 'noLink') {
              blockForm = true;
            }
            if (this.typeOfUpload === 'LinkToNewBox') {
              if (this.isFormValid) {
                blockForm = true;
              }
            }
            if (this.typeOfUpload === 'LinkExisting') {
              if (Object.values(this.selectedBoxes).length > 0) {
                blockForm = true;
              }
            }
            return blockForm;
          }
        },
        data() {
          var boxTypes = Constants.boxTypesWithoutSmartBox;
          var trackTypes = Constants.trackTypes;
          let currentBoxType = boxTypes.BOX.value;
          let currentTrackType = trackTypes.MUSIC.value;

          if (this.$route.params && this.$route.params.boxType) {
            if (this.$route.params.boxType === 'UNDEFINED') {
              currentBoxType = Constants.boxTypes['PLAYLIST'].value
            } else {
              let trackType = Constants.trackTypes[this.$route.params.boxType]
              if (trackType) {
                currentTrackType = trackType.value
              }
            }
          }
            return {
              trackType: null,
              typeOfUpload : 'noLink',
              stationBoxes: {},
              selectedBoxes: {},
              royaltyFree: false,
              boxData: {
                stationUid: this.$route.params.stationUid,
                name: "",
                type: currentBoxType,
                colorCode: "#ff6a00",
                trackType: currentTrackType,
                styles:'',
                categories:'',
                targets:'',
              },
              viewState: {
                showStyleSelector: false,
                showCategoriesSelector: false,
                showTargetSelector: false,
              },
              creationResponse: null
            };
        },
      mounted() {
        // this.loadStations();
      },
        watch: {
            type: {
                handler: function (newV) {
                    if(newV === "PENDING") {
                        this.trackType = currentStation.allowTrackUpload 
                                            ? Constants.trackTypes['MUSIC'] : Constants.trackTypes['JINGLE'];
                    } 
                    else {
                        this.trackType = Constants.trackTypes[newV]
                    }
                },
                immediate: true
            }
        },

        methods: {
          getError(field) {
            return this.errors.indexOf(field) >= 0 || this.errors.indexOf(field.toLowerCase()) >= 0;
          },
          openParameterSelector(toggler, selectorName, tracks) {
            if (!tracks || tracks.length === 0) return;
            this.viewState[toggler] = true;

            try {
              var modalSelector = this.$refs[selectorName];

              if (modalSelector) {
                modalSelector.editForTracks(tracks);
              }
            } catch (e) {
              console.log("exc:", e);
            }
          },
          onNewValueTargets(field, value) {
           console.log(field, value);
            this.boxData.targets = value;
          },
          onNewValueCategories(field, value) {
            console.log(field, value);
            this.boxData.categories = value;
          },
          onNewValueStyles(field, value) {
            console.log(field, value);
            this.boxData.styles = value;
          },
          resetModalState(toggler) {

          },
          onFocus(field) {
            this.$set(this.viewState, "fieldFocused", field);
          },
          onBlur() {
            this.$set(this.viewState, "fieldFocused", null);
          },
          show() {
            this.clean();
            this.loadStations();
            this.$refs.modal.show();
          },
          hide() {
            this.$refs.modal.hide();
          },
          confirm() {
            console.log(this.royaltyFree);
            if (this.typeOfUpload === 'noLink') {
              if (this.trackType) {
                this.$emit("confirmed", this.files, this.currentRouteName || this.trackType.value , null , this.royaltyFree);
                this.hide();
              }
            }
            if (this.typeOfUpload === 'LinkToNewBox') {
              this.createBoxUp();
            }
            if (this.typeOfUpload === 'LinkExisting') {
              console.log(this.selectedBoxes)
              if (this.trackType ){
                let listBoxUuid = [];
                for (let item in this.selectedBoxes) {
                  console.log(item);
                  listBoxUuid.push(item);
                  }
                this.$emit("confirmed", this.files, this.currentRouteName || this.trackType.value , listBoxUuid , this.royaltyFree);
                this.hide();
              }
            }


          },
          // Load Stations
          async loadStations() {
            console.log(this.stationUid)
            console.log(this.$route.params.stationUid)
            var response = await HTTP.get(Apis.station.list, {params: {pageSize: 10000}});
            if (response.data.dataItem) {
              console.log('stationUid', response.data.dataItem)
              this.stations = response.data.dataItem;
              if (this.stations.items && this.stations.items.length > 0) {
                var activateStation = this.stations.items
                        .find(station => station.uid.localeCompare(this.$route.params.stationUid) == 0)
                    || this.stations.items[0]
                if (activateStation) {
                  this.activateStation(activateStation);
                }
              }
            }
          },
          activateStation(station) {
            console.log('stationUid', station)
            this.activeStation = station;
            this.loadStationsBox(station.uid);
          },
          async loadStationsBox(stationUid) {
            var response = await HTTP.get(Apis.boxes.search, {
              params: {
                RadioUid: stationUid,
                sortField: "name",
                sortAscending: true,
                pageSize: 0,
                page: 0
              }
            });

            if (response.data.dataItem) {
              console.log('this.stationBoxes', this.stationBoxes)
              console.log('stationUid', stationUid)
              console.log('response.data.dataItem', response.data.dataItem)
              this.$set(this.stationBoxes, stationUid, response.data.dataItem);
              console.log('this.stationBoxes', this.stationBoxes)
            }
          },
          toggleBox(box) {
            console.log(this.selectedBoxes , box.type)
            if (box.type !== 'BOX'){
              if (this.selectedBoxes[box.uid]) {
                this.$set(this.selectedBoxes, box.uid, null);
                delete this.selectedBoxes[box.uid];
              } else {
                box.station = this.activeStation;
                if (Object.values(this.selectedBoxes).length === 0) {
                  this.selectedBoxes = {
                    [box.uid]: {...box}
                  }
                } else {
                  this.$set(this.selectedBoxes, box.uid, box);
                }

              }
            } else {
              box.station = this.activeStation;
              if (Object.values(this.selectedBoxes).length === 0) {
                this.selectedBoxes = {
                  [box.uid]: {...box}
                }
              } else {
                for (let item in this.selectedBoxes) {
                  for (let itemComplete in this.stationMusicBoxes) {
                    console.log()
                  if (item === this.stationMusicBoxes[itemComplete].uid){
                    if( this.stationMusicBoxes[itemComplete].type === 'BOX'){
                      box.station = this.activeStation;
                      this.$set(this.selectedBoxes, item, null);
                      delete this.selectedBoxes[item];
                      this.$set(this.selectedBoxes, box.uid, box);
                    }
                  }

                  }
                }
                this.$set(this.selectedBoxes, box.uid, box);
              }

            }
            console.log(this.selectedBoxes)
          },

          createBoxUp() {
            if (this.isFormValid) {
              const vm = this;

             this.boxData.categories = this.TransformDataCategories(this.boxData.categories);
             this.boxData.styles = this.TransformDataStyles(this.boxData.styles);
             this.boxData.targets = this.TransformDataTargets(this.boxData.targets);
              HTTP.post("api/boxes/create", this.boxData)
                  .then(this.onBoxCreated, this.onBoxCreationError)
                  .then(function () {
                    console.log("End...")
                   // await  this.refreshBoxStats({ stationUid: this.boxData.stationUid , reloadAll:true});
                   //  vm.$store.dispatch("loadStationBoxes",
                   //      {
                   //        stationUid: vm.$route.params.stationUid,
                   //       // reloadAll:true,
                   //      })
                    store.dispatch('loadStationBoxes', vm.$route.params.stationUid);
                  });
            }
          },
          onBoxCreated(response) {
            this.creationResponse = response;
            if (this.creationResponse.status === 200) {
              const newBox = this.creationResponse.data;
              // newBox.dataItem.uid
              console.log(newBox.dataItem.uid)
               if (this.trackType ){
                this.$emit("confirmed", this.files, this.currentRouteName || this.trackType.value , [newBox.dataItem.uid], this.royaltyFree);
                this.hide();
               }

            } else {
              //let vue build the error messages
            }
            //this.cancelModal();
          },
          onBoxCreationError(response) {
            // console.log(response);
            this.creationResponse = response;
            // console.error(response);
          },
          TransformDataCategories(data){
            if ( data){
              let array = [];
              for (let i = 0; i < data.length; i++) {
                array.push({'categoryId': data[i].id });
              }
              return array;
            }

          },
          TransformDataStyles(data){
            if ( data) {
              let array = [];
              for (let i = 0; i < data.length; i++) {
                array.push({'styleId': data[i].id});
              }
              return array;
            }
          },
          TransformDataTargets(data){
            if ( data) {
              let array = [];
              for (let i = 0; i < data.length; i++) {
                array.push({'targetId': data[i].id});
              }
              return array;
            }
          },
          clean(){
            this.selectedBoxes = {};
            this.royaltyFree= false;
            this.typeOfUpload = 'noLink';
            this.boxData.name = "";
            this.boxData.colorCode = "#ff6a00";
          },
        },

    };
</script>

<style lang="scss" scoped>
    .upload {
        width: 480px;
    }

    header {
        font-size: 26px;
        color: #292c33;
        text-align: center;

        padding: 35px;
    }

    .body {
        padding: 0 35px 35px 35px;

        h3 {
            color: #696b70;
            font-size: 13px;
        }
    }

    .count {
        color: #000;
        font-weight: 600;
    }

    footer {
        border-top: 1px solid #d2d2d2;
        height: 80px;
        padding: 35px;

        a {
            color: #d2d2d2;
            text-transform: uppercase;
            font-size: 13px;
        }

        button {
            text-transform: uppercase;
        }
    }
    .upload-box{
        li{
            height: auto;
            input{
                &[type=radio]{
                    height: 24px;
                }
            }
            label{
                margin: 0;
            }
        }
    }
    .search-container {
      overflow: hidden;
      height: 100%;
      height:400px;
      display:flex;
      flex-direction:column;
      flex-grow: 1;
      justify-content: stretch;
      align-self: flex-start;
      ul{
        height: 100%;
        overflow: auto;
        input{
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.7px;
          line-height: 1;
        }
        li {
          span{
            font-weight:600;
            font-size:12px
          }
          span.badge {
            font-weight:400;
            font-size:10px
          }
        }
      }
    }

    .box-source-wrapper {
      position: relative;
      padding-left: 25px;

      i {
        position: absolute;
        left: 0;
        top: 5px;
      }
    }

    .search-container .search-content {
      display: flex;
      flex-grow: 1;
      flex-direction: row;
      flex-shrink: 0;
      height: 100%;
    }

    .source-column li.header {
      position: sticky;
      top: 0;
      background:#fff;
      z-index:100;
      padding: 10px;
      border-bottom: 1px solid #dee2e6;
      height:41px;
      display:flex;
      align-items: center;
    }

    #station-source.source-column {
      width: 70%;
      height: 100%;
      overflow: auto;
    }

    #box-source.source-column {
      width: 50%;
      flex-shrink: 0;
      border-right: 1px solid #dee2e6;
    }

    .search-container header {
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      padding: 10px 15px;
      border-bottom: var(--COLOR_BORDERS) 1px solid;
    }

    .search-container header h4 {
      margin: 0;
    }

    .source-column li {
      height: auto;
      padding: 7px 10px;
      align-items: baseline;
    }

    .source-column li i {
      margin-right: 15px;
    }

    .source-column li i:hover {
      margin-right: 15px;
      color: var(--COLOR_BRAND);
    }



    .source-column li .station-label {
      font-size: 12px;
      font-weight: 600;
    }

    .source-column li i.fa-check {
      opacity: 0.1;
      transition: color 0.2s ease-in-out;
    }

    .source-column li.active i.fa-check {
      opacity: 1;
      color: var(--COLOR_BRAND);
    }
    .source-column{
      li {
        .input{
          width: 100%;
        }
      }
    }

</style>
